/* ASELECION – Lade-Platzhalter beim Seitenwechsel + Bild-Shimmer + externe Links im neuen Tab + Lesefortschritt */
(function(){
 var OWN=/(^|\.)aselecion\.(de|com|es|cz)$|(^|\.)myshopify\.com$/;
 function ext(a){try{var u=new URL(a.getAttribute('href'),location.href);return /^https?:$/.test(u.protocol)&&!OWN.test(u.hostname)}catch(e){return false}}
 function extLinks(root){(root||document).querySelectorAll('a[href]').forEach(function(a){if(ext(a)){a.target='_blank';var r=(a.getAttribute('rel')||'').split(/\s+/);['noopener','noreferrer'].forEach(function(x){if(r.indexOf(x)<0)r.push(x)});a.setAttribute('rel',r.join(' ').trim())}})}
 var sk=null;
 function skel(){
  if(sk)return sk;sk=document.createElement('div');sk.className='asel-skel';sk.setAttribute('aria-hidden','true');
  sk.innerHTML='<div class="w"><i></i><b></b><b></b><em></em><span></span><span></span><span></span><span></span><span></span><span></span></div>';
  document.body.appendChild(sk);return sk;
 }
 window.ASEL_LEAVE=function(){skel();requestAnimationFrame(function(){document.documentElement.classList.add('asel-leaving')})};
 function reset(){document.documentElement.classList.remove('asel-leaving')}
 window.addEventListener('pageshow',reset);
 document.addEventListener('click',function(e){
  var a=e.target.closest&&e.target.closest('a[href]');if(!a)return;
  if(ext(a)){a.target='_blank';a.rel='noopener noreferrer';return}
  if(e.defaultPrevented||e.button!==0||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey)return;
  if(a.target==='_blank'||a.hasAttribute('download'))return;
  var u;try{u=new URL(a.href,location.href)}catch(x){return}
  if(!/^https?:$/.test(u.protocol))return;
  if(u.pathname===location.pathname&&u.search===location.search&&u.hash)return;
  window.ASEL_LEAVE();
 },true);
 function imgs(){
  document.querySelectorAll('.card .img img,.ar-cover img').forEach(function(im){
   if(im.complete&&im.naturalWidth)return;var p=im.parentNode;p.classList.add('sk');
   function done(){p.classList.remove('sk')}
   im.addEventListener('load',done,{once:true});im.addEventListener('error',done,{once:true});
  });
 }
 function prog(){
  var bar=document.createElement('div');bar.className='asel-prog';bar.setAttribute('aria-hidden','true');document.body.appendChild(bar);
  var cur=0,target=0,raf=0;
  function measure(){var h=document.documentElement.scrollHeight-innerHeight;target=h>innerHeight*.5?Math.min(1,Math.max(0,scrollY/h)):0;bar.classList.toggle('on',h>innerHeight*.5&&scrollY>8);if(!raf)raf=requestAnimationFrame(tick)}
  function tick(){cur+=(target-cur)*.25;if(Math.abs(target-cur)<.0005)cur=target;bar.style.transform='scaleX('+cur.toFixed(4)+')';raf=cur!==target?requestAnimationFrame(tick):0}
  addEventListener('scroll',measure,{passive:true});addEventListener('resize',measure);addEventListener('load',measure);measure();
 }
 function go(){imgs();extLinks();prog()}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',go);else go();
})();
